export const LICENSE_INFORMATION = 'licenseInformation';
export const LICENSE_COUNTS = 'licenseCounts';
export const FAMILY_METADATA = 'familyMetadata';
export const METADATA = 'metadata';
export const DETAILS = 'details';
export const APPLICATIONS = 'applications';
export const APPLICATION_BASE = 'application_base';
export const APPLICATION_NAME = 'application_name';
export const APPLICATION_BASE_NAME = 'application_base_name';
export const USER_LICENSING = 'user_licensing';
export const USAGE_LICENSING = 'usage_licensing';
export const SITE_LICENSING = 'site_licensing';
export const ACTIVE_SITES = 'active_sites';
export const ARCHIVE_SITES = 'archive_sites';
export const SITE_BASED = 'site_based';
export const USER_BASED = 'user_based';
export const INVESTIGATOR_PORTAL_SITES = 'investigator_portal_sites';
export const LICENSING_MODEL = 'licensing_model';
export const LICENSING_DOMAIN = 'licensing_domain';
export const MODEL = 'model';

export const MANAGED_SERVICE_USERS = 'managed_service_users';
export const DOCUMENT_BUNDLES = 'document_bundles';
export const STATION_DEVICE_LICENSES = 'station_device_licenses';
export const NOTES = 'notes';

export const USED = 'used';
export const LICENSED = 'licensed';
export const SHARED = 'shared';

export const LABEL = 'label';
export const LABELS = 'labels';
export const NAME = 'name';
export const TYPE = 'type';
export const START_DATE = 'start_date';
export const TERM = 'term';
export const PROPERTIES = 'properties';
export const VALUES = 'values';

export const PER_USER = 'per_user';
export const APP_LICENSE_POOL = 'app_license_pool';
export const MULTI_APP_LICENSE_POOL = 'multi_app_license_pool';
export const MEMBER_USERTYPES = 'member_usertypes';
